import { jsx } from "react/jsx-runtime";
import { forwardRef } from "react";
import DialogSystem from "@mui/material/Dialog";
import "@mui/material/Modal";
import "@mui/material/Paper";
const Dialog = forwardRef(
  function Dialog2(inProps, ref) {
    const { eventId, ...props } = inProps;
    return /* @__PURE__ */ jsx(DialogSystem, { ...props, ref, "data-eventid": eventId });
  }
);
export {
  Dialog
};
//# sourceMappingURL=dialog.component.js.map
